import jsPDF from "jspdf";
// import autotable from "jspdf-autotable";
import html2canvas from "html2canvas";
import axios from "axios";


export async function calculateRunningBalance(client, ledgerType, userInfo, authToken, GetAllLedgersAPI, transactionType = null, activityType = null) {
  console.log('client8', client);
  try {
    // Build query based on ledger type
    let query = `&accountId=${client._id}&transactionType=challan&transactionType=credit&transactionType=debit`;

    if (ledgerType === "Bill") {
      query = `&accountId=${client._id}&transactionType=bill&transactionType=credit&transactionType=debit`;
    }

    // Add specific transaction type filter if provided
    if (transactionType) {
      query += `&type=${transactionType}`;
    }

    // Add specific activity type filter if provided
    if (activityType) {
      query += `&activityType=${activityType}`;
    }

    // Get all ledger records for the client
    const response = await axios.get(GetAllLedgersAPI(userInfo.entity) + query, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const ledgers = response.data.ledgers || [];
    console.log('allRecords1', ledgers.length);

    // Get opening balance based on ledger type
    const openingBalance = ledgerType === "Challan"
      ? (client.openingChallanBalance || 0)
      : (client.openingBillBalance || 0);

    // Calculate running balance from all ledger entries
    const runningBalance = ledgers.reduce((sum, record) => {
      const amount = Number(record.amount) || 0;
      console.log('record.amount', record.amount, sum, amount);
      // Handle Challan transactions
      if (record.transactionType === "challan" || record.transactionType === "credit" || record.transactionType === "debit") {
        if (record.type === "credit" && record.activityType === "purchase") {
          return sum + amount;
        } else if (record.type === "credit" && record.activityType === "sale") {
          return sum - amount;
        } else if (record.type === "debit" && record.activityType === "sale") {
          return sum + amount;
        } else if (record.type === "debit" && record.activityType === "purchase") {
          return sum - amount;
        }
      }

      // Handle Bill transactions
      if (record.transactionType === "bill") {
        if (record.type === "credit" && record.activityType === "purchase") {
          return sum + amount;
        }
        else if (record.type === "credit" && record.activityType === "sale") {
          return sum - amount;
        } else if (record.type === "debit" && record.activityType === "sale") {
          return sum + amount;
        } else if (record.type === "debit" && record.activityType === "purchase") {
          return sum - amount;
        }
      }

      return sum;
    }, 0);

    // Add opening balance to the calculated running balance
    const finalBalance = runningBalance + openingBalance;
    console.log('finalBalance78', finalBalance);
    return finalBalance;

  } catch (error) {
    console.error('Error calculating running balance:', error);
    // Return opening balance as fallback
    return ledgerType === "Challan"
      ? (client.openingChallanBalance || 0)
      : (client.openingBillBalance || 0);
  }
}

export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export const injectHTML = (htmlCode) => {
  let iframe = document.getElementById("previewIframe");

  let iframedoc = iframe.document;
  if (iframe.contentDocument) {
    iframedoc = iframe.contentDocument;
  } else if (iframe.contentWindow) {
    iframedoc = iframe.contentWindow.document;
  }

  if (iframedoc) {
    iframedoc.open();
    iframedoc.writeln(htmlCode);
    iframedoc.close();
  }
};

export function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);

  // separate out the mime component
  let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to a typed array
  let ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

export async function htmlTemplateToDataString(
  htmlTemplate,
  options,
  callback
) {
  const pageWidthPt = options?.width || options?.format?.[0] || 850;

  const addPageNumbersIfRequested = (docOut) => {
    if (!options?.addPageNumbers) return;
    try {
      const totalPages = docOut?.internal?.getNumberOfPages?.() || 0;
      if (!totalPages) return;

      const startAt = Number.isFinite(Number(options?.pageNumberStart))
        ? Number(options.pageNumberStart)
        : 1;

      const marginOpt = options?.margin || 0;
      const margin = Array.isArray(marginOpt)
        ? marginOpt
        : [
            Number(marginOpt) || 0,
            Number(marginOpt) || 0,
            Number(marginOpt) || 0,
            Number(marginOpt) || 0,
          ];
      const [, mRight, mBottom] = margin;

      const pageW = docOut.internal.pageSize.getWidth();
      const pageH = docOut.internal.pageSize.getHeight();
      const y = pageH - Math.max(10, Number(mBottom) * 0.6);
      const x = pageW - Math.max(10, Number(mRight) || 10);

      docOut.setFontSize(9);
      docOut.setTextColor(0, 0, 0);

      for (let p = 1; p <= totalPages; p++) {
        docOut.setPage(p);
        const label = `Page ${startAt + p - 1}`;
        docOut.text(label, x, y, { align: "right" });
      }
    } catch (_) {
      // best-effort only
    }
  };

  // Force single-page rendering by rasterizing the HTML to a single canvas image,
  // then embedding it into a single tall PDF page. This avoids jsPDF.html auto-pagination.
  if (options?.forceSinglePage) {
    const MAX_PDF_PAGE_HEIGHT_PT = 14000; // practical limit; avoids viewer/library issues
    const marginPt = Number.isFinite(Number(options?.pageMarginPt))
      ? Number(options.pageMarginPt)
      : 0;
    const usableWidthPt = Math.max(pageWidthPt - marginPt * 2, 50);
    const renderWidthPx = Number.isFinite(Number(options?.renderWidthPx))
      ? Number(options.renderWidthPx)
      : Math.max(900, Math.round(pageWidthPt));

    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.style.position = "fixed";
    iframe.style.left = "-10000px";
    iframe.style.top = "0";
    iframe.style.width = `${renderWidthPx}px`;
    iframe.style.height = "1px";
    iframe.style.visibility = "hidden";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) {
      document.body.removeChild(iframe);
      const fallbackPdf = new jsPDF(options);
      const dataString = await fallbackPdf.output("datauristring");
      callback(dataString);
      return;
    }

    doc.open();
    doc.write(htmlTemplate);
    doc.close();

    // Allow layout to settle
    await new Promise((r) => requestAnimationFrame(() => r()));

    // Wait briefly for images (logo/QR) to load
    const imgEls = Array.from(doc.images || []);
    const waitImages = Promise.all(
      imgEls.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) return resolve();
            img.onload = () => resolve();
            img.onerror = () => resolve();
          })
      )
    );
    await Promise.race([waitImages, new Promise((r) => setTimeout(r, 2000))]);

    await new Promise((r) => requestAnimationFrame(() => r()));

    const target = doc.body;
    const el = doc.documentElement;
    const fullWidthPx = Math.max(el?.scrollWidth || 0, target?.scrollWidth || 0, renderWidthPx);
    const fullHeightPx = Math.max(el?.scrollHeight || 0, target?.scrollHeight || 0, 0);

    // Render full page into one canvas
    const canvas = await html2canvas(target, {
      scale: 1,
      useCORS: true,
      logging: false,
      allowTaint: true,
      imageTimeout: 0,
      backgroundColor: "#ffffff",
      scrollX: 0,
      scrollY: 0,
      windowWidth: fullWidthPx,
      windowHeight: fullHeightPx || 1,
    });

    const canvasWidthPx = canvas.width || fullWidthPx || renderWidthPx;
    const canvasHeightPx = canvas.height || fullHeightPx || 0;
    const ptPerPx = usableWidthPt / (canvasWidthPx || usableWidthPt);
    let pdfHeightPt = Math.ceil(canvasHeightPx * ptPerPx);

    // Clamp height to avoid PDF viewer limits; if clamped, the invoice will be scaled down.
    if (!Number.isFinite(pdfHeightPt) || pdfHeightPt <= 0) {
      pdfHeightPt = options?.format?.[1] || 1066;
    }
    const unclampedHeightPt = pdfHeightPt;
    pdfHeightPt = Math.min(pdfHeightPt + marginPt * 2, MAX_PDF_PAGE_HEIGHT_PT);

    const pdf = new jsPDF({
      orientation: options?.orientation || "p",
      unit: options?.unit || "pt",
      format: [pageWidthPt, pdfHeightPt],
      putOnlyUsedFonts: options?.putOnlyUsedFonts ?? true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.92);
    const drawHeightPt =
      unclampedHeightPt > MAX_PDF_PAGE_HEIGHT_PT ? pdfHeightPt : unclampedHeightPt;

    // Draw within margins to avoid printer clipping
    pdf.addImage(imgData, "JPEG", marginPt, marginPt, usableWidthPt, drawHeightPt);

    document.body.removeChild(iframe);

    addPageNumbersIfRequested(pdf);
    const dataString = await pdf.output("datauristring");
    callback(dataString);
    return;
  }

  // Force multi-page rendering by rasterizing the HTML once to a canvas,
  // then slicing it into multiple PDF pages. This reliably enforces per-page
  // top/bottom margins even when jsPDF.html autoPaging ignores margin/y.
  if (options?.forceCanvasPaging) {
    const pageHeightPt = options?.format?.[1] || 1066;
    const marginOpt = options?.margin || 0;
    const margin = Array.isArray(marginOpt)
      ? marginOpt
      : [
        Number(marginOpt) || 0,
        Number(marginOpt) || 0,
        Number(marginOpt) || 0,
        Number(marginOpt) || 0,
      ];
    const [mTop, mRight, mBottom, mLeft] = margin;
    const usableWidthPt = Math.max(pageWidthPt - (mLeft + mRight), 50);
    const usableHeightPt = Math.max(pageHeightPt - (mTop + mBottom), 50);

    const renderWidthPx = Number.isFinite(Number(options?.renderWidthPx))
      ? Number(options.renderWidthPx)
      : Math.max(900, Math.round(pageWidthPt));

    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.style.position = "fixed";
    iframe.style.left = "-10000px";
    iframe.style.top = "0";
    iframe.style.width = `${renderWidthPx}px`;
    iframe.style.height = "1px";
    iframe.style.visibility = "hidden";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) {
      document.body.removeChild(iframe);
      const fallbackPdf = new jsPDF(options);
      const dataString = await fallbackPdf.output("datauristring");
      callback(dataString);
      return;
    }

    doc.open();
    doc.write(htmlTemplate);
    doc.close();

    await new Promise((r) => requestAnimationFrame(() => r()));

    // Wait briefly for images (logo/QR) to load
    const imgEls = Array.from(doc.images || []);
    const waitImages = Promise.all(
      imgEls.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) return resolve();
            img.onload = () => resolve();
            img.onerror = () => resolve();
          })
      )
    );
    await Promise.race([waitImages, new Promise((r) => setTimeout(r, 2000))]);
    await new Promise((r) => requestAnimationFrame(() => r()));

    const target = doc.body;
    const el = doc.documentElement;
    const fullWidthPx = Math.max(
      el?.scrollWidth || 0,
      target?.scrollWidth || 0,
      renderWidthPx
    );
    const fullHeightPx = Math.max(el?.scrollHeight || 0, target?.scrollHeight || 0, 0);

    const canvas = await html2canvas(target, {
      scale: 1,
      useCORS: true,
      logging: false,
      allowTaint: true,
      imageTimeout: 0,
      backgroundColor: "#ffffff",
      scrollX: 0,
      scrollY: 0,
      windowWidth: fullWidthPx,
      windowHeight: fullHeightPx || 1,
    });

    const canvasWidthPx = canvas.width || fullWidthPx || renderWidthPx;
    const canvasHeightPx = canvas.height || fullHeightPx || 0;

    const ptPerPx = usableWidthPt / (canvasWidthPx || usableWidthPt);
    const sliceHeightPx = Math.max(Math.floor(usableHeightPt / (ptPerPx || 1)), 1);

    const pdf = new jsPDF({
      orientation: options?.orientation || "p",
      unit: options?.unit || "pt",
      format: [pageWidthPt, pageHeightPt],
      putOnlyUsedFonts: options?.putOnlyUsedFonts ?? true,
    });

    // Slice the big canvas into page-sized chunks
    let yPx = 0;
    let pageIndex = 0;
    while (yPx < canvasHeightPx) {
      const remainingPx = canvasHeightPx - yPx;
      const thisSlicePx = Math.min(sliceHeightPx, remainingPx);

      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = canvasWidthPx;
      pageCanvas.height = thisSlicePx;
      const ctx = pageCanvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(
          canvas,
          0,
          yPx,
          canvasWidthPx,
          thisSlicePx,
          0,
          0,
          canvasWidthPx,
          thisSlicePx
        );
      }

      const imgData = pageCanvas.toDataURL("image/jpeg", 0.92);
      const drawHeightPt = thisSlicePx * ptPerPx;

      if (pageIndex > 0) pdf.addPage();
      pdf.addImage(imgData, "JPEG", mLeft, mTop, usableWidthPt, drawHeightPt);

      yPx += thisSlicePx;
      pageIndex += 1;
    }

    document.body.removeChild(iframe);
    addPageNumbersIfRequested(pdf);
    const dataString = await pdf.output("datauristring");
    callback(dataString);
    return;
  }

  // Row-aware paging: slice canvas at row boundaries so table rows are never cut.
  // Requires options.rowAwarePaging === true and options.itemsTableId (e.g. "invoice-items-table").
  if (options?.rowAwarePaging && options?.itemsTableId) {
    const pageHeightPt = options?.format?.[1] || 1066;
    const marginOpt = options?.margin || 0;
    const margin = Array.isArray(marginOpt)
      ? marginOpt
      : [
        Number(marginOpt) || 0,
        Number(marginOpt) || 0,
        Number(marginOpt) || 0,
        Number(marginOpt) || 0,
      ];
    const [mTop, mRight, mBottom, mLeft] = margin;
    const usableWidthPt = Math.max(pageWidthPt - (mLeft + mRight), 50);
    const usableHeightPt = Math.max(pageHeightPt - (mTop + mBottom), 50);

    const renderWidthPx = Number.isFinite(Number(options?.renderWidthPx))
      ? Number(options.renderWidthPx)
      : Math.max(900, Math.round(pageWidthPt));

    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.style.position = "fixed";
    iframe.style.left = "-10000px";
    iframe.style.top = "0";
    iframe.style.width = `${renderWidthPx}px`;
    iframe.style.height = "1px";
    iframe.style.visibility = "hidden";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) {
      document.body.removeChild(iframe);
      const fallbackPdf = new jsPDF(options);
      const dataString = await fallbackPdf.output("datauristring");
      callback(dataString);
      return;
    }

    doc.open();
    doc.write(htmlTemplate);
    doc.close();

    await new Promise((r) => requestAnimationFrame(() => r()));

    const imgEls = Array.from(doc.images || []);
    const waitImages = Promise.all(
      imgEls.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) return resolve();
            img.onload = () => resolve();
            img.onerror = () => resolve();
          })
      )
    );
    await Promise.race([waitImages, new Promise((r) => setTimeout(r, 2000))]);
    await new Promise((r) => requestAnimationFrame(() => r()));

    const target = doc.body;
    const el = doc.documentElement;
    const fullWidthPx = Math.max(
      el?.scrollWidth || 0,
      target?.scrollWidth || 0,
      renderWidthPx
    );
    const fullHeightPx = Math.max(
      el?.scrollHeight || 0,
      target?.scrollHeight || 0,
      0
    );

    // Row boundaries: get tbody rows from the items table and their positions relative to body.
    const table = doc.getElementById(options.itemsTableId);
    const rows = table ? Array.from(table.querySelectorAll("tbody tr")) : [];
    const bodyRect = target.getBoundingClientRect();
    const bodyScrollTop = target.scrollTop || 0;

    const rowTops = [];
    const rowBottoms = [];
    for (const row of rows) {
      const r = row.getBoundingClientRect();
      rowTops.push(r.top - bodyRect.top + bodyScrollTop);
      rowBottoms.push(r.bottom - bodyRect.top + bodyScrollTop);
    }

    // Segments: [above table], [row0], [row1], ..., [below table]. No segment crosses a row.
    let segments = [];
    if (rowTops.length > 0) {
      const tableTop = rowTops[0];
      const tableBottom = rowBottoms[rowBottoms.length - 1];
      segments.push([0, tableTop]);
      for (let i = 0; i < rowBottoms.length; i++) {
        segments.push([rowTops[i], rowBottoms[i]]);
      }
      segments.push([tableBottom, fullHeightPx]);
    } else {
      segments.push([0, fullHeightPx]);
    }

    const canvas = await html2canvas(target, {
      scale: 1,
      useCORS: true,
      logging: false,
      allowTaint: true,
      imageTimeout: 0,
      backgroundColor: "#ffffff",
      scrollX: 0,
      scrollY: 0,
      windowWidth: fullWidthPx,
      windowHeight: fullHeightPx || 1,
    });

    const canvasWidthPx = canvas.width || fullWidthPx || renderWidthPx;
    const canvasHeightPx = canvas.height || fullHeightPx || 0;
    const ptPerPx = usableWidthPt / (canvasWidthPx || usableWidthPt);
    const sliceHeightPx = Math.max(
      Math.floor(usableHeightPt / (ptPerPx || 1)),
      1
    );

    // Pack segments into pages: page boundary only between segments, never inside a row.
    const boundaries = [0];
    let pageFill = 0;
    for (const [segTop, segBottom] of segments) {
      const segHeight = segBottom - segTop;
      if (pageFill > 0 && pageFill + segHeight > sliceHeightPx) {
        boundaries.push(segTop);
        pageFill = 0;
      }
      pageFill += segHeight;
    }
    boundaries.push(fullHeightPx);

    const pdf = new jsPDF({
      orientation: options?.orientation || "p",
      unit: options?.unit || "pt",
      format: [pageWidthPt, pageHeightPt],
      putOnlyUsedFonts: options?.putOnlyUsedFonts ?? true,
    });

    for (let i = 0; i < boundaries.length - 1; i++) {
      const yPx = Math.round(boundaries[i]);
      const nextY = Math.round(boundaries[i + 1]);
      const thisSlicePx = Math.min(
        nextY - yPx,
        Math.max(0, canvasHeightPx - yPx)
      );
      if (thisSlicePx <= 0) continue;

      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = canvasWidthPx;
      pageCanvas.height = thisSlicePx;
      const ctx = pageCanvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(
          canvas,
          0,
          yPx,
          canvasWidthPx,
          thisSlicePx,
          0,
          0,
          canvasWidthPx,
          thisSlicePx
        );
      }

      const imgData = pageCanvas.toDataURL("image/jpeg", 0.92);
      const drawHeightPt = thisSlicePx * ptPerPx;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "JPEG", mLeft, mTop, usableWidthPt, drawHeightPt);
    }

    document.body.removeChild(iframe);
    addPageNumbersIfRequested(pdf);
    const dataString = await pdf.output("datauristring");
    callback(dataString);
    return;
  }

  // Default (existing) behavior
  let pdf = new jsPDF(options);
  window.scrollTo(0, 0);
  window.html2canvas = html2canvas;

  // Apply consistent per-page margins for jsPDF.html pagination.
  // NOTE: options.unit is typically "pt" here. For 10px vertical spacing:
  // 10px ≈ 7.5pt (because 1px ≈ 0.75pt at 96dpi).
  const marginOpt = options?.margin || 0;
  const margin = Array.isArray(marginOpt)
    ? marginOpt
    : [Number(marginOpt) || 0, Number(marginOpt) || 0, Number(marginOpt) || 0, Number(marginOpt) || 0];
  const [mTop, mRight, mBottom, mLeft] = margin;
  const usableWidthPt = Math.max(pageWidthPt - (mLeft + mRight), 50);
  const pageHeightPt = options?.format && options?.format?.[1] ? options.format[1] : undefined;
  const usableHeightPt =
    typeof pageHeightPt === "number" ? Math.max(pageHeightPt - (mTop + mBottom), 50) : undefined;

  pdf.html(htmlTemplate, {
    html2canvas: {
      scale: 1,
      useCORS: true,
      logging: false,
      allowTaint: true,
      imageTimeout: 0,
    },
    // x/y are applied at the start of each new page during autoPaging
    x: mLeft || 0,
    y: mTop || 0,
    width: usableWidthPt,
    windowWidth: pageWidthPt,
    height: usableHeightPt,
    windowHeight: options?.windowHeight,
    // "text" tends to respect layout better for tables than slicing
    autoPaging: options?.autoPaging || "text",
    margin: margin,
    callback: async function (docOut) {
      addPageNumbersIfRequested(docOut);
      let dataString = await docOut.output("datauristring");
      callback(dataString);
    },
  });
}

let a = [
  "",
  "One ",
  "Two ",
  "Three ",
  "Four ",
  "Five ",
  "Six ",
  "Seven ",
  "Eight ",
  "Nine ",
  "Ten ",
  "Eleven ",
  "Twelve ",
  "Thirteen ",
  "Fourteen ",
  "Fifteen ",
  "Sixteen ",
  "Seventeen ",
  "Eighteen ",
  "Nineteen ",
];
let b = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

export function inWords(num) {
  if ((num = num.toString()).length > 9) {
    return "overflow";
  }
  let n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) {
    return;
  }
  let str = "";
  str +=
    n[1] != 0
      ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "Crore "
      : "";
  str +=
    n[2] != 0
      ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "Lakh "
      : "";
  str +=
    n[3] != 0
      ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "Thousand "
      : "";
  str +=
    n[4] != 0
      ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "Hundred "
      : "";
  str +=
    n[5] != 0
      ? (str != "" ? "and " : "") +
      (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
      "Rupees Only "
      : "";
  return str;
}
export function inWords2(num) {
  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const paise = [
    "Zero Paise",
    "One Paise",
    "Two Paise",
    "Three Paise",
    "Four Paise",
    "Five Paise",
    "Six Paise",
    "Seven Paise",
    "Eight Paise",
    "Nine Paise",
  ];

  const n = Number(num);
  if (!Number.isFinite(n) || n < 0) {
    return "Zero ";
  }
  let rupees = Math.floor(n);
  let paisa = Math.round((n - rupees) * 100);

  let rupeesInWords = "";

  if (rupees === 0) {
    rupeesInWords = "Zero";
  } else {
    if (Math.floor(rupees / 10000000) > 0) {
      rupeesInWords += inWords2(Math.floor(rupees / 10000000)) + " Crore ";
      rupees %= 10000000;
    }

    if (Math.floor(rupees / 100000) > 0) {
      rupeesInWords += inWords2(Math.floor(rupees / 100000)) + " Lakh ";
      rupees %= 100000;
    }

    if (Math.floor(rupees / 1000) > 0) {
      rupeesInWords += inWords2(Math.floor(rupees / 1000)) + " Thousand ";
      rupees %= 1000;
    }

    if (Math.floor(rupees / 100) > 0) {
      rupeesInWords += inWords2(Math.floor(rupees / 100)) + " Hundred ";
      rupees %= 100;
    }

    if (rupees > 0) {
      if (rupeesInWords !== "") rupeesInWords += "and ";
      if (rupees < 10) rupeesInWords += units[rupees];
      else if (rupees === 10) rupeesInWords += "Ten";
      else if (rupees < 20) rupeesInWords += teens[rupees - 10];
      else {
        rupeesInWords += tens[Math.floor(rupees / 10)];
        if (rupees % 10 > 0) rupeesInWords += " " + units[rupees % 10];
      }
    }

    rupeesInWords += " ";
  }

  // let paisaInWords = paise[paisa];
  // if (paisa > 0) paisaInWords += " and " + paise[paisa];

  return rupeesInWords;
}

export function formatBytes(a, b) {
  if (0 == a) {
    return "0 Bytes";
  }
  let c = 1024,
    d = b || 2,
    e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
}


/**
 * Per-piece net rate after discount: ((qty × rate) − discount) / qty.
 * Matches ChallanAddDialog amount logic (excludes fitting/tint).
 */
export function calcChallanNetRate(item) {
  const qty = Number(item?.quantity) || 0;
  const rate = Number(item?.rate);
  if (!qty || !Number.isFinite(rate)) return "";

  let lineBase = rate * qty;
  const disPerUnit = Number(item.discountAmount) || 0;
  if (disPerUnit > 0) lineBase -= disPerUnit * qty;
  const pct = Number(item.discountPercent) || 0;
  if (pct > 0) lineBase -= (lineBase * pct) / 100;

  return (Math.round((lineBase / qty) * 100) / 100).toFixed(2);
}

export function formatAmount(amount) {
  let [integerPart, decimalPart] = amount.toString().split('.');
  const lastThreeDigits = integerPart.slice(-3);
  const otherDigits = integerPart.slice(0, -3);
  const formattedIntegerPart = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + (otherDigits ? "," : "") + lastThreeDigits;
  return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
}

export function formatINRCurrency(amount) {
  const numValue = Number(amount);
  if (isNaN(numValue)) return amount;
  return numValue.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "INR",
  });
}

export async function sendWhatsAppMessage(number, orderDetails) {
  console.log("orderDetails", orderDetails);
  console.log("number", number);
  try {
    const response = await axios.post(
      "https://graph.facebook.com/v22.0/322268540966210/messages",
      {
        messaging_product: "whatsapp",
        to: number,
        type: "template",
        template: {
          name: "welcome_new_client_2",
          language: { code: "en" },
          components: [
            {
              type: "body",
              parameters: [
                {
                  type: "text",
                  text: `✅ Your order has been received!\n\n📋 *Order Details:*\n${JSON.stringify(orderDetails, null, 2)}`,
                },
              ],
            },
          ],
        },
      },
      {
        headers: {
          Authorization: `Bearer EAAPyCRZBtNU4BO3XHHMSLvFeoj2ZAmmcxArGbAFWCu3O6t2P0ApZAp9IfO1icaayJVXn9m4XP2OjQyoLhnYJL4Q35XXA2oZCZBZAg3grxeVcoDrO4QuR4aP44Hkk2vLSqkIBFwu7XN8IZCLtl2SwZC82LQ3eqZBfZCLCDARmF8jcwhcce1biZATSqrZC6SZCoE6Cw6X6p`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("WhatsApp Message Sent Successfully:", response.data);
  } catch (error) {
    console.error("Failed to Send WhatsApp Message:", error.response?.data || error.message);
  }
}